let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gBkKI")).then(() => parcelRequire('d6xSf'));